export { generateSoftwareApplicationSchema } from './softwareApplicationSchema';
export { generateFAQSchema } from './faqSchema';
export { generateJsonLd, JsonLd } from './generateJsonLd';
export type { FAQItem } from './faqSchema';
